
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import { Dictionary } from "vue-router/types/router";
import tablePagination from "@/mixins/table-pagination";
import tableFilters from "@/mixins/table-filters";
import { parseArrayParams } from "@/services/helpers";
import ImageViewer from "@/components/viewers/Image.vue";
import { mask } from "vue-the-mask";
import DateRangePicker from "@/components/form-components/DateRangePicker.vue";

export default Vue.extend({
  name: "employees",

  mixins: [tablePagination, tableFilters],

  components: {
    DateRangePicker,
    ImageViewer
  },

  directives: { mask },

  data: () => ({
    parseArrayParams,
    filter: {} as Dictionary<string | boolean | (string | null)[]>,
    headers: [] as Array<any>,
    items: [] as Array<any>,
    loading: false as boolean,
    selects: {
      genders: [
        { value: "f", text: "F" },
        { value: "m", text: "M" }
      ] as Array<SelectComponentInterface>,
      departmentsList: [] as Array<SelectComponentInterface>,
      users: [] as Array<SelectComponentInterface>
    } as any,
    showMenu: false as boolean,
    x: 0,
    y: 0,
    activeItemId: null
  }),

  computed: {
    maxDate(): any {
      const date = new Date();
      return new Date(date.getFullYear() - 8, date.getMonth(), date.getDate());
    }
  },

  async beforeRouteEnter(to, from, next) {
    try {
      if (to.query.birthdate) {
        to.query.birthdate = (to.query.birthdate as string).split(",");
      }

      const params = {
        filter: to.query,
        page: {
          number: to.params.page,
          size: 48
        }
      };
      const response = await API.employees().getData(params);
      const departmentsList = await API.subdivisions().getList();
      const serviceTypes = await API.serviceTypes().getList();
      const workPositions = await API.workPositions().getList();
      const users = await API.users().getList();

      next(vm => {
        vm.setFilters(params.filter);
        vm.setServerResponse(response);
        vm.selects.subdivisions = departmentsList.items;
        vm.selects.serviceTypes = serviceTypes;
        vm.selects.workPositions = workPositions;
        vm.selects.users = users;
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    async loadData(): Promise<void> {
      this.loading = true;
      try {
        const response = await this.$API.employees().getData({
          filter: this.parseArrayParams(this.filter),
          page: this.pagination,
          sort: this.getSortParams()
        });
        this.setServerResponse(response);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    },
    async deleteRow(id: number): Promise<void> {
      this.loading = true;
      try {
        await this.$API.employees().delete(id);
        await this.$store.dispatch(
          "alert/showSuccess",
          this.$t("global_alert.successful_removal")
        );
        await this.loadData();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
      this.loading = false;
    },
    setServerResponse({ items, headers }: any) {
      this.headers = [
        ...headers,
        {
          text: "",
          value: "actions",
          width: "100px",
          align: "center",
          sortable: false
        }
      ];

      this.items = items.data;
      this.totalItems = items.total;
    },
    setFilters(filter: Dictionary<string | (string | null)[]>): void {
      const newFilters = this.getAvailableFilters(filter);

      if (Object.keys(newFilters).length) {
        this.showFilters = true;
      }

      this.filter = newFilters;
      this.changeActiveFilters();
    },
    search() {
      if (this.debounced) {
        this.debounced.cancel();
      }
      this.debounced = this.debounce(500, this.applyFilters);
      this.debounced();
    },
    showContextMenu(e: any, item: any) {
      this.activeItemId = item.item.id;
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    }
  }
});
